<script>
export default {
  functional: true,
  props: {
    isNext: {
      default: true
    }
  },
  render(h, context) {
    const direction = context.props.isNext ? "up" : "down";

    var data = {
      props: {
        name: `data-driven-transition--${direction}`,
        mode: "out-in"
      }
    };
    return h("transition", data, context.children);
  }
};
</script>

<style>
.data-driven-transition--up-enter-active,
.data-driven-transition--up-leave-active,
.data-driven-transition--down-enter-active,
.data-driven-transition--down-leave-active {
  transition: 0.8s;
}

.data-driven-transition--up-enter,
.data-driven-transition--up-leave-to {
  opacity: 0;
  transform: translateY(-140px);
}

.data-driven-transition--down-enter,
.data-driven-transition--down-leave-to {
  opacity: 0;
  transform: translateY(140px);
}
</style>